<main class="main">
  <div class="main-box">
    <div class="column-1">
      <div class="levitate-image-box">
        <img
          src="/assets/Main/Emblems/Figma.svg"
          alt="Фигма"
          class="levitate-image Figma"
          style="--rotation: -15.42deg"
          width="130"
          height="130"
          loading="lazy"
        />
      </div>
      <h1 style="--rotation: 15deg">
        Разработка сайтов, мобильных приложений и веб-решений на заказ
      </h1>
      <div class="welcome">
        Вместе с нами ваш бизнес станет более технологичным, конкурентоспособным
        и успешным.
      </div>
      <button (click)="openContactsMenu()" class="order-button">
        Заказать проект
      </button>
    </div>
    <div class="columns">
      <div class="column-2">
        <div class="images-container">
          <div class="levitate-image-box">
            <img
              src="/assets/Main/Emblems/Python.svg"
              alt="питон"
              class="levitate-image Python"
              style="--rotation: -5.42deg"
              width="130"
              height="130"
              loading="lazy"
            />
          </div>
          <div class="levitate-image-box">
            <img
              src="/assets/Main/Emblems/Visual Studio.svg"
              alt="вс код"
              class="levitate-image VS"
              style="--rotation: 10.58deg"
              width="110"
              height="110"
              loading="lazy"
            />
          </div>
          <div class="levitate-image-box">
            <img
              src="/assets/Main/Emblems/SQLite.svg"
              alt="Эскьюэль"
              class="levitate-image SQL"
              style="--rotation: -5.58deg"
              width="75"
              height="75"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="scrolling-stack">
    <div class="stack stack-content-1">
      <span>MySQL</span>
      <span>CSS</span>
      <span>Figma</span>
      <span>Flask</span>
      <span>Python</span>
      <span>Flutter</span>
      <span>NumPy</span>
      <span>Git</span>
      <span>PostgresSQL</span>
      <span>Angular</span>
      <span>TypeScript</span>
      <span>Pandas</span>
      <span>FastApi</span>
      <span>HTML</span>
    </div>
    <div class="stack stack-content-2">
      <span>MySQL</span>
      <span>CSS</span>
      <span>Figma</span>
      <span>Flask</span>
      <span>Python</span>
      <span>Flutter</span>
      <span>NumPy</span>
      <span>Git</span>
      <span>PostgresSQL</span>
      <span>Angular</span>
      <span>TypeScript</span>
      <span>Pandas</span>
      <span>FastApi</span>
      <span>HTML</span>
    </div>
  </div>
</main>
